import { render, staticRenderFns } from "./pass_reset.vue?vue&type=template&id=39478f45&scoped=true&"
import script from "./pass_reset.vue?vue&type=script&lang=js&"
export * from "./pass_reset.vue?vue&type=script&lang=js&"
import style0 from "./pass_reset.vue?vue&type=style&index=0&id=39478f45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39478f45",
  null
  
)

export default component.exports